import { Box, CardProps } from "theme-ui";
import React, { FC, ReactElement } from "react";

export type CardPrimaryType = {
  hasPadding?: boolean;
} & CardProps;

export const Card: FC<CardPrimaryType> = ({
  children,
  hasPadding,
  ...props
}: CardPrimaryType): ReactElement => (
  <Box variant={hasPadding ? "cards.padding" : "cards.primary"} {...props}>
    {children}
  </Box>
);

Card.defaultProps = {
  hasPadding: false,
};
